import React from "react";
import SEO from "@/lib/seo-static.json";
import { PricingSection } from "@/components/sections/Pricing";
import ROICalculator from "@/components/sections/ROICalculator";
import { FAQSection, CTABand } from "@/components/sections/Social";
import { usePageTitle } from "@/components/ui-kit";
import { FAQ } from "@/lib/site";
import ExitIntent from "@/components/ExitIntent";

export default function Pricing() {
  usePageTitle(SEO["/pricing"].title, SEO["/pricing"].description, SEO["/pricing"].image);
  return (
    <div data-testid="pricing-page">
      <ExitIntent page="/pricing" />
      <PricingSection full />
      <ROICalculator />
      <FAQSection items={FAQ.slice(0, 6)} title="Pricing questions." eyebrow="Billing FAQ" />
      <CTABand title="Start small. Switch on more when you're ready." desc="Every plan includes a 7-day free trial. Upgrade, downgrade or cancel whenever you like." />
    </div>
  );
}
